module.exports = __webpack_public_path__ + "img/gorilla_cointreasure.72cd0fa.png";